import { ProLayoutProps } from '@ant-design/pro-components';
import { Colors } from './colors';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  locale: 'en-US',
  navTheme: 'light',
  colorPrimary: Colors.primaryColor,
  layout: 'side',
  contentWidth: 'Fluid',
  fixedHeader: false,
  fixSiderbar: true,
  colorWeak: false,
  title: '',
  pwa: true,
  iconfontUrl: '',
  token: {
    // 参见ts声明，demo 见文档，通过token 修改样式
    //https://procomponents.ant.design/components/layout#%E9%80%9A%E8%BF%87-token-%E4%BF%AE%E6%94%B9%E6%A0%B7%E5%BC%8F
    colorPrimary: Colors.primaryColor,
    header: {
      colorBgHeader: Colors.secondaryColor,
      colorHeaderTitle: Colors.headerColor,
    },
    sider: {
      colorMenuBackground: Colors.backgroundColor,
      colorTextMenu: '#929CAC',
    },
    pageContainer: {
      // Kill the layout content wrapper's default 32px/40px padding, which
      // shows as a white frame around every page.
      paddingBlockPageContainerContent: 0,
      paddingInlinePageContainerContent: 0,
    },
  },
};

export default Settings;
